import React from 'react';
import { motion } from 'framer-motion';
import { FaRocket } from 'react-icons/fa';
import { BackgroundPaths } from './ui/background-paths';

const HeroWithPaths = () => {
  return (
    <section id="home" className="relative min-h-screen">
      <BackgroundPaths
        title="Software Development Club"
        buttonText="Explore Our Work"
        buttonHref="#technologies"
      />

      {/* Welcome Badge */}
      <div className="absolute top-20 md:top-24 left-1/2 -translate-x-1/2 z-20 flex justify-center w-full">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.5 }}
          className="inline-flex items-center space-x-2 glass-strong px-6 py-3 rounded-full border border-primary/30"
        >
          <FaRocket className="text-primary animate-pulse" />
          <span className="text-sm font-mono text-light">Welcome to SDC</span>
        </motion.div>
      </div>

      {/* Tagline */}
      <div className="absolute bottom-32 left-1/2 -translate-x-1/2 z-20 max-w-4xl w-full px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 2 }}
          className="text-center space-y-4"
        >
          <p className="text-lg md:text-xl text-gray-300 font-medium">
            Where <span className="text-primary font-semibold">innovation</span> meets{' '}
            <span className="text-emerald font-semibold">collaboration</span>
          </p>
          <p className="text-sm md:text-lg text-gray-400 font-mono">
            {`{ Building the future, one commit at a time }`}
          </p>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.5, repeat: Infinity, duration: 2 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20"
      >
        <div className="flex flex-col items-center space-y-2 text-gray-400">
          <span className="text-xs font-mono uppercase tracking-wider">Scroll to explore</span>
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default HeroWithPaths;
